import { gql } from 'glimmer-apollo';

export const GAMES_INDEX_QUERY = gql`
  query {
    articles: gameArticles(limit: 10) {
      title
      slug
      shortDescription
      publishedDate
      body
      coverImage {
        url
      }
      author {
        displayName
        profilePicture {
          url
        }
      }
    }
  }
`;
